import { request } from '@/utils/request'
import getUrlParams from '@/utils/getUrlParams'
import { getDeviceId, getUUID } from '@/utils/analysis'

export function caiji (activityId) {
  return request.get(process.env.VUE_APP_CAIJI_API, {
    baseURL: '',
    params: {
      deviceid: getDeviceId(),
      userUuid: getUUID(),
      userAgent: navigator.userAgent,
      dataType: 1000099,
      actionTime: new Date().valueOf(),
      url: window.location.href.split('#')[0],
      origin: 11,
      action: 1,
      activityId,
    },
  })
}
